
import React, { useState, useEffect } from 'react'
import { Switch } from 'react-router-dom'
import { RouteWithSubRoutes } from "../../config/Router";
import circle from '../../img/circulogris.png';
import universe from '../../img/logo_final_png.png'
import { logout } from '../../actions/authActions';
import { connect, useDispatch, useSelector } from 'react-redux'
import Logout from '../../components/User/Logout';
import ModalMenu from '../../containers/ModalMenu';
import inMemoryJWT from '../../auth/inMemoryJwt';
import { LogoBorder, MessagePendingIcon, NotificationsPendingIcon } from '../../assets/icons';
import useModal from '../../utils/hooks/useModal';
import ModalMessages from '../../components/Rooms/ModalMessages';
import ModalNotification from '../../components/User/ModalNotification';
import { getNotificationsAddressee } from '../../actions/notificationsActions';
import localStorage from '../../utils/hooks/useLocalStorage';
import LinkAdmin from './LinkAdmin/LinkAdmin';
import { getMyAdminInfo } from '../actions/permissionsAction';

const HomeAdmin = ({ routes, history, logout }) => {
    const dispatch = useDispatch()
    const [refMessages, isShowMessages, setIsShowMessages] = useModal(false)
    const [refNotification, isShowNotification, setIsShowNotification] = useModal(false)
    const { listNotificationsAddresse } = useSelector(state => state.notifications)
    const { adminInfo } = useSelector(state => state.permissionsAdmin)
    const [notificacion, setNotification] = useState(0)

    useEffect(() => {
        //  if(!islogin){
        dispatch(getNotificationsAddressee(false))
        dispatch(getMyAdminInfo(localStorage().getItem("idProfile")))
        // }

    }, [])
    useEffect(() => {
        if (!(inMemoryJWT.getToken())) {
            inMemoryJWT.getRefreshedToken()
        }
    })


    const contentModalAdmin = <div className='scroll-menu modal-menu-navbar-content text-black'>
        <div className="modal-menu-navbar-content-items">
            <div>
                <div className="mb-4">Menú</div>
                <Logout
                    renderClose={<div onClick={() => {
                        logout(history)
                    }} >
                        <button className="btn btn-purple btn-small">Cerrar sesion</button>
                    </div>}
                />
            </div>
        </div>
    </div>
    return (
        <div>
            <div className={`navbar-component`}>
                <div className='content-icons-navbar'>
                    <div onClick={() => history.push('/')} className={`icon-navbar first-icon-navbar`}>
                        <div className="logo-full-navbar">
                            <img src={universe} height={50}></img>
                        </div>
                        <div className="logo-only-navbar">
                            <LogoBorder className="icon-50-navbar" />
                        </div>
                    </div>
                    <div className="spreader-bar-navbar"></div>
                    <div ref={refMessages} className="content-icon-navbar">
                        <div className={`icon-navbar ${isShowMessages && false ? 'active-icon-navbar' : ''} ${history.location.pathname.includes('Messages') && false ? 'active-icon-navbar' : ''}`}
                            onClick={() => { !history.location.pathname.includes('Messages') && setIsShowMessages(!isShowMessages) }}>
                            <MessagePendingIcon className="icon-normal-navbar" />
                        </div>
                        {isShowMessages && <ModalMessages
                            isProfessionalUser={false}
                            isAdmin={true}
                            displayModal={isShowMessages}
                            setIsShowMessages={setIsShowMessages}
                            setNotificationMsg={() => { }}
                        //setMessage={setMessage}
                        />}
                    </div>
                    <div className="spreader-bar-navbar"></div>
                    <div ref={refNotification} className="content-icon-navbar" >
                        <div className={`icon-navbar ${isShowNotification && false ? 'active-icon-navbar' : ''}`}
                            onClick={() => { setIsShowNotification(!isShowNotification) }}
                            style={{
                                content: ""
                            }}
                        >
                            <NotificationsPendingIcon className="icon-normal-navbar" />
                            <div className="icon-normal-navbar-counter"><div>{
                                listNotificationsAddresse.request.filter(notification => !notification.doYouSeeTheNotification).length +
                                listNotificationsAddresse.othersNotifications.filter(notification => !notification.doYouSeeTheNotification).length +

                                listNotificationsAddresse.paymentsNotifications.filter(notification => !notification.doYouSeeTheNotification).length
                            }</div></div>

                        </div>

                        {isShowNotification && <ModalNotification
                            isProfessionalUser={false}
                            displayModal={isShowNotification}
                            setIsShowNotification={setIsShowNotification}
                            setNotification={setNotification}
                        />}
                    </div>
                    <div className="spreader-bar-navbar"></div>
                    <div className="navbar-higth column centerItems endContent">

                        <div className="text-name-navbar mr-2">{localStorage().getItem("nameUser") ? localStorage().getItem("nameUser").split(' ')[0] : 'Welcome'}
                        </div>
                        <ModalMenu
                            contentButton={localStorage().getItem("picturProfile") ? <img alt="img" className="img-navbar-profile mr-2" onError={(e) => e.target.src = circle} src={localStorage().getItem("picturProfile")}></img> :
                                <img alt="img" className="img-navbar-profile mr-2" src={circle}></img>
                            }
                            contentModal={contentModalAdmin}
                        />
                    </div>
                </div>

                {/*
                  <div className="column centerItems ml-5" >
                    <img onClick={() => history.push('/Admin')} alt="img" className="img-logo-navbar" src={universe}></img>
                </div >
                <div ref={refNotification} className="content-icon-navbar" >
                    <div className={`icon-navbar ${isShowNotification && false ? 'active-icon-navbar' : ''}`}
                        onClick={() => { setIsShowNotification(!isShowNotification) }}
                        style={{
                            content: ""
                        }}
                    >
                        <NotificationsPendingIcon className="icon-normal-navbar" />
                        <div className="icon-normal-navbar-counter"><div>{
                            listNotificationsAddresse.request.filter(notification => !notification.doYouSeeTheNotification).length +
                            listNotificationsAddresse.othersNotifications.filter(notification => !notification.doYouSeeTheNotification).length +

                            listNotificationsAddresse.paymentsNotifications.filter(notification => !notification.doYouSeeTheNotification).length
                        }</div></div>

                    </div>

                    {isShowNotification && <ModalNotification
                        isProfessionalUser={false}
                        displayModal={isShowNotification}
                        setIsShowNotification={setIsShowNotification}
                        setNotification={setNotification}
                    />}
                </div>
                <div className="content-search-bar row centerContent endItems">
                    <div className={`icon-navbar ${isShowMessages && false ? 'active-icon-navbar' : ''} ${history.location.pathname.includes('Messages') && false ? 'active-icon-navbar' : ''}`}
                        onClick={() => { !history.location.pathname.includes('Messages') && setIsShowMessages(!isShowMessages) }}>
                        <MessagePendingIcon className="icon-normal-navbar" />
                    </div>
                    {isShowMessages && <ModalMessages
                        isProfessionalUser={false}
                        isAdmin={true}
                        displayModal={isShowMessages}
                        setIsShowMessages={setIsShowMessages}
                        setNotificationMsg={() => { }}
                    //setMessage={setMessage}
                    />}
                </div>

              
                <div className="navbar-higth column centerItems endContent">

                    <div className="text-name-navbar mr-2">{localStorage().getItem("nameUser") ? localStorage().getItem("nameUser").split(' ')[0] : 'Welcome'}
                    </div>
                    <ModalMenu
                        contentButton={localStorage().getItem("picturProfile") ? <img alt="img" className="img-navbar-profile mr-2" onError={(e) => e.target.src = circle} src={localStorage().getItem("picturProfile")}></img> :
                            <img alt="img" className="img-navbar-profile mr-2" src={circle}></img>
                        }
                        contentModal={contentModalAdmin}
                    />
                </div> */}
            </div>
            <div className="column">
                <div className="navbar-lateral-admin scroll-menu">
                    <LinkAdmin
                        permission="PER014"
                        link={"/Admin/Inventory/PrincipalInventoryMenu"}
                        text={"Inventario"}
                    />
                    <LinkAdmin
                        permission="PER013"
                        link={"/Admin/ListZones"}
                        text={"Zonas"}
                    />
                    <LinkAdmin
                        permission="PER020"
                        link={"/Admin/ListRoles"}
                        text={"Roles administrador"}
                    />
                    <LinkAdmin
                        permission="PER012"
                        link={"/Admin/ListAdmin"}
                        text={"Usuarios administrador"}
                    />
                    <LinkAdmin
                        permission="PER009"
                        link={"/Admin/CategorieAdmin"}
                        text={"Categorías Salas y Zonas"}
                    />
                    <LinkAdmin
                        permission="PER005"
                        link={"/Admin/PointPackageAdmin"}
                        text={"Paquetes de puntos"}
                    />
                    <LinkAdmin
                        permission="PER002"
                        link={"/Admin/MainCampaigns"}
                        text={"Puntos de Campañas"}
                    />
                    <LinkAdmin
                        permission="PER011"
                        link={"/Admin/ReportCategorieAdmin"}
                        text={"Tipos de reporte"}
                    />
                    <LinkAdmin
                        permission="PER004"
                        link={"/Admin/SeeLimitsReportAdmin"}
                        text={"Parámetros del admin"}
                    />
                   {/*  <LinkAdmin
                        permission="PER015"
                        link={"/Admin/ReportBaneAdmin"}
                        text={"Baneo para reportados"}
                    /> */}
                    <LinkAdmin
                        permission="PER015"
                        link={"/Admin/reportedContent"}
                        text={"Contenidos reportados"}
                    />
                    <LinkAdmin
                        permission="PER015"
                        link={"/Admin/ReportListAdmin"}
                        text={"Lista de reportados"}
                    />
                    <LinkAdmin
                        permission="PER016"
                        link={"/Admin/CertificateStateConceptAdmin"}
                        text={"Lista de Solicitud de Verificar Cuenta"}
                    />
                    <LinkAdmin
                        permission="PER017"
                        link={"/Admin/TobeFranchiseList"}
                        text={"Lista de Solicitud de Ser EcoTienda"}
                    />
                    <LinkAdmin
                        permission="PER018"
                        link={"/Admin/TobeRepresentativeList"}
                        text={"Lista de Solicitud de Ser EcoMaster"}
                    />
                    <LinkAdmin
                        permission="PER010"
                        link={"/Admin/ActionAwardsAdmin"}
                        text={"Lista de acciones"}
                    />
                    <LinkAdmin
                        permission="PER003"
                        link={"/Admin/RanksAdmin"}
                        text={"Lista de Rangos"}
                    />
                    <LinkAdmin
                        permission="PER019"
                        link={"/Admin/PQRSAdmin"}
                        text={"PQRS"}
                    />

                    <LinkAdmin
                        permission="PER022"
                        link={"/Admin/Jobs"}
                        text={"Ofertas de empleo"}
                    />
                      <LinkAdmin
                        permission="PER022"
                        link={"/Admin/Advertisings"}
                        text={"Publicidad"}
                    />
                </div>
                <div className="container-admin-funtion">
                    <Switch>
                        {routes.map((route, i) => (
                            <RouteWithSubRoutes key={i} {...route} />
                        ))}
                    </Switch>
                </div>

            </div>

        </div>

    )
}

export default connect(null, { logout })(HomeAdmin)